<wa-card class="card-header">
   <div slot="header" class="wa-heading-s">Statistics</div>
  <div class="wa-cluster">
    <wa-bar-chart label="Users" orientation="horizontal" [withoutLegend]="true" [config]="chartConfigUsersSignal()">
    </wa-bar-chart>
    <wa-bar-chart label="Workload" orientation="horizontal" [withoutLegend]="true" legendPosition="right"
                  [config]="chartConfigWorkloadSignal()">
    </wa-bar-chart>
    <wa-bar-chart label="Optimization Results" orientation="horizontal" [withoutLegend]="true" legendPosition="right"
                  [config]="chartConfigOptimizationSignal()">
    </wa-bar-chart>
  </div>
</wa-card>
